var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "关联", name: "first" } },
            [
              _c(
                "div",
                {
                  staticClass: "mt10 mb10",
                  staticStyle: { overflow: "hidden" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "swb-btn swb-btn-small mr5 fr",
                      on: { click: _vm.saveAdoptedDeviceRel }
                    },
                    [_vm._v("保存")]
                  )
                ]
              ),
              _vm._v(" "),
              _c("swb-adopted-device-list-select", {
                ref: "swb_adopted_device_list_select",
                attrs: {
                  nxtActiveName: _vm.activeName,
                  catId: _vm.catId,
                  brandId: _vm.brandId,
                  fixedSpec: _vm.fixedSpec,
                  model: _vm.model,
                  centBuyMode: _vm.centBuyMode,
                  notAssetDefFlag: _vm.notAssetDefFlag,
                  skuFlag: _vm.skuFlag,
                  checkIds: _vm.checkIds,
                  filter: _vm.filter,
                  showTable: true,
                  showCatBrandTable: true
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "查看", name: "second" } },
            [
              _c("swb-asmbl-acc-def-rel-device-list", {
                ref: "swb_asmbl_acc_def_rel_device_list",
                attrs: { activeName: _vm.activeName, filter: _vm.showFilter }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-035d0596", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-035d0596","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/devcDef/MerchtDevcAsset.vue
// module id = 2424
// module chunks = 0